<template>
  <div class="pc-menu">
    <div class="pc-mobile-block">
      <div class="pc-user">
        {{ userFullName }}
      </div>
      <pc-language-switcher theme="light" />
    </div>
    <ul>
      <li
        v-for="item in menu"
        :key="item.title"
        :class="{'active': item.isActive, opened: item.opened}"
        class="pc-menu__item"
      >
        <div
          class="pc-menu__item-title"
          @click="goTo(item)"
        >
          <div class="pc-menu__icon-wrap" :class="{'has-new': getHasNew(item) }">
            <icu-icon
              class="pc-menu__icon"
              :class="{[item.icon]: true}"
            />
          </div>
          {{ $t(item.title) }}
        </div>
        <ul v-if="item.submenu" class="pc-submenu">
          <li
            v-for="subItem in item.submenu"
            :key="subItem.component"
            class="pc-menu_subitem"
            :class="{'active':subItem.isActive}"
            @click="goTo(subItem)"
          >
            <div class="pc-menu__icon-wrap" :class="{'has-new': getHasNew(subItem) }">
              <icu-icon
                class="pc-menu__icon"
                :class="{[subItem.icon]: true}"
              />
            </div>
            {{ $t(subItem.title) }}
          </li>
        </ul>
      </li>
      <li class="pc-menu__item">
        <div
          class="pc-menu__item-title"
          @click="logout"
        >
          <div class="pc-menu__icon-wrap">
            <icu-icon
              class="pc-menu__icon pc-exit"
            />
          </div>
          {{ $t('pc.menu.exit') }}
        </div>
      </li>
    </ul>
  </div>

</template>

<script>
import IcuIcon from '@/components/common/IcuIcon'
import PcLanguageSwitcher from '@/components/common/PcLanguageSwitcher'
import {mapGetters} from 'vuex'
import PcModalWrapper from '@/components/modals/PcModalWrapper'
import PcModalContainer from '@/components/modals/PcModalContainer'

export default {
  name: 'PcMenu',
  components: {PcModalContainer, PcModalWrapper, PcLanguageSwitcher, IcuIcon},
  data() {
    return {
      isDesktop: true,
      nonReadMessages: false,
      nonSignedDocuments: false,
      nonReadDocuments: false,
      menu: [
        {
          title: 'pc.menu.my-profile',
          component: 'profile',
          icon: 'pc-user2',
          submenu: [
              {
                title: 'pc.menu.security',
                icon: 'pc-info',
                component:'profile'
              },
              {
                title: 'pc.menu.funds',
                icon: 'pc-bag',
                component:'accounts'
              }
          ]
        },
        // {
        //   title: 'pc.menu.document-request',
        //   icon: 'pc-add-doc',
        //   component: 'document-request'
        // },
        {
          title: 'pc.menu.documents',
          icon: 'pc-doc',
          component: 'documents-all',
        },
        {
          title: 'pc.menu.trade-limits',
          icon: 'pc-alert',
          component: 'trade-limits'

        },
        {
          title: 'pc.menu.messages',
          icon: 'pc-message',
          component: 'messages'
        }
      ],
      showExitModal: false,

    }
  },
  watch: {
    '$route'(newVal){
      this.setActiveMenuItems()
    },
    'userInfo.unread_docs': {
      handler(newVal) {
        this.nonReadDocuments = newVal
      },
      immediate: true
    },
    'userInfo.unread_unsigned_docs': {
      handler(newVal) {
        this.nonSignedDocuments = newVal
      },
      immediate: true
    },
    'userInfo.unread_messages': {
      handler(newVal) {
        this.nonReadMessages = newVal
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters(['userFullName', 'userInfo']),
    getHasNew(){
      return item => {
        switch (item.component) {
          case 'documents':
            return this.nonReadDocuments || this.nonSignedDocuments
          case 'documents-all':
            return this.nonReadDocuments
          case 'documents-for-sign':
            return this.nonSignedDocuments
          case 'messages':
            return this.nonReadMessages
          default:
            return false
        }
      }
    },
  },
  mounted() {
    this.setActiveMenuItems()
    this.checkDesktop()
    window.addEventListener('resize', this.checkDesktop)
  },
  destroyed() {
    window.removeEventListener('resize', this.checkDesktop)
  },
  methods: {
    checkDesktop() {
      this.isDesktop = window.innerWidth > 1200
    },
    goTo(item) {

      this.$store.dispatch('setUserInfo')
      if(!this.isDesktop && !!item.submenu?.length) {
        const index = this.menu.findIndex(el => el.component === item.component )
        this.$set(this.menu[index], 'opened', !this.menu[index].opened )
        if(!this.menu[index].isActive) {
          this.menu[index].isActive = false
        }
        return
      }
      if (item.component !== this.$route.name) {
        this.$emit('close')
          this.$router.push({name: item.component === 'documents' ? 'documents-all' : item.component})
          this.menu.forEach(el => el.opened = false)

      }
    },

    setActiveMenuItems(){
      const curComponent = this.$route.name
     this.menu.map(item => {
        if(item.submenu) {
          const hasActiveSubItem  = item.submenu.filter(subitem => {
            this.$set(subitem, 'isActive', subitem.component === curComponent)
            return subitem.isActive
          })
          this.$set(item, 'isActive', !!hasActiveSubItem.length)
        } else {
          this.$set(item, 'isActive', item.component === curComponent)
        }
      })
    },
    logout() {
      this.$emit('logout')
    }
  }

}
</script>

<style scoped>
.pc-menu__item {
  list-style: none;
}
</style>
